const Messaging = window.tnew.ui.messaging;

const Key = {
  Page: 'opg--page',
  AmountEntry: 'opg--amount',
};

const addPageError = msg => Messaging.addError(msg, true, Key.Page);

export default {
  addPageError,
  clearErrors: () => Messaging.clearErrors(),
};
